export default {"src":"/_next/static/media/crypto.a01b3768.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};